import { msalInstance, loginRequest } from "@/config/authConfig";

export const authService = {
  getAccessToken: async (): Promise<string | null> => {
    const account = msalInstance.getActiveAccount();
    if (!account) return null;

    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      return response.accessToken;
    } catch (error) {
      // Silent token acquisition failed; return null and let the
      // 401 interceptor / auth guard handle re-authentication.
      return null;
    }
  },

  isAuthenticated: (): boolean => {
    return msalInstance.getActiveAccount() !== null;
  },
};
